import { Auth, default as AppContainer, UserContextProvider } from '@qpr/client-library';
import QprThemeProvider from '@qpr/theme';
import LogoutPage from '@qpr/user/components/Logout';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'typeface-open-sans';
import 'typeface-roboto';
import BusinessPortalAppBar from './components/BusinessPortalAppBar';
import AppBarContext from './components/BusinessPortalAppBarContext';
import useAppBar from './components/BusinessPortalAppBarHook';
import ErrorBanner from './components/ErrorBanner';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/Register';
import Routes from './Routes';
import versionInfoText from './version.json';

const VersionInfo = () => <>{JSON.stringify(versionInfoText)}</>;

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/logout" component={LogoutPage} />
        <Route path="/register" component={RegisterPage} />
        <Route path="/version" component={VersionInfo} />
        <Route>
          <AppContainer>
            <QprThemeProvider themeName="landing-page">
              <Auth loginPage={<LoginPage />}>
                <UserContextProvider>
                  <AppBarContext.Provider value={useAppBar()}>
                    <BusinessPortalAppBar />
                    <ErrorBanner />
                    <Routes />
                  </AppBarContext.Provider>
                </UserContextProvider>
              </Auth>
            </QprThemeProvider>
          </AppContainer>
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
